import { render, staticRenderFns } from "./CardData.vue?vue&type=template&id=c595fc60&"
import script from "./CardData.vue?vue&type=script&lang=js&"
export * from "./CardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports